var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcAuthGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0011 11.4221C21.0011 10.7075 20.9416 9.99295 20.8226 9.29297H10.7188V13.3324H16.5072C16.2691 14.6303 15.4954 15.7969 14.3645 16.5261V19.151H17.8167C19.8405 17.3281 21.0011 14.6303 21.0011 11.4221Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7205 21.6865C13.6073 21.6865 16.0477 20.7532 17.8184 19.149L14.3662 16.5241C13.3989 17.1658 12.1639 17.5303 10.7205 17.5303C7.92294 17.5303 5.55695 15.6783 4.70877 13.1992H1.15234V15.9116C2.96776 19.4553 6.67298 21.6865 10.7205 21.6865Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.70789 13.1993C4.26148 11.9014 4.26148 10.4869 4.70789 9.1744V6.47656H1.15147C-0.381218 9.43689 -0.381218 12.9368 1.15147 15.8971L4.70789 13.1993Z",
    fill: "#FBBC04"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7205 4.84426C12.2531 4.81509 13.7263 5.38383 14.8275 6.41921L17.8928 3.41514C15.9435 1.63602 13.3841 0.658969 10.7205 0.688135C6.67298 0.688135 2.96776 2.9339 1.15234 6.47754L4.70877 9.18996C5.55695 6.69629 7.92294 4.84426 10.7205 4.84426Z",
    fill: "#EA4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAuthGoogle);
export default __webpack_public_path__ + "static/media/ic_auth_google.50cdb1ed7474f0afa9c8f49d1e420365.svg";
export { ForwardRef as ReactComponent };